export function productSectionGalleryEvents() {
	const galleries = document.querySelectorAll(".flux-product-section-gallery");
	if (!galleries.length) return;

	galleries.forEach((gallery) => {
		const handleFirstClick = async (event) => {
			const trigger = event.target.closest("[data-product-section-gallery-item]");
			if (!trigger) {
				return;
			}

			gallery.removeEventListener("click", handleFirstClick);
			try {
				const { initProductSectionGallery } = await import(
					"./product-section-gallery.js"
				);
				const handleGalleryClick = initProductSectionGallery(gallery);
				handleGalleryClick(event);
			} catch (err) {
				console.error("Failed to load module:", err);
			}
		};

		gallery.addEventListener("click", handleFirstClick);
	});
}
